export default __webpack_public_path__ + "static/IDpro-0a427bb9c8e807336a73734a265cc3ad.png";